export default "__VITE_ASSET__CDkX1ETC__"